import {useEffect, useState} from 'react'
import getDistanceFromLatLonInKm from '@helpers/misc/coordinatesDistance'

import {SHORT_RANGE_DISTANCE_THRESHOLD} from './constants'

const ANIM_FPS = 40

const easeInOut = (t: number) => {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
}

export default function useSmoothLocation(originalLocation: {lat: number; lng: number}) {
  const [smoothLocation, setSmoothLocation] = useState(originalLocation)
  const [isFinal, setIsFinal] = useState(true)

  // Animate the location using an ease-in-out animation
  useEffect(() => {
    if (!originalLocation?.lat || !originalLocation?.lng) return
    if (!smoothLocation?.lat || !smoothLocation?.lng) {
      setSmoothLocation(originalLocation)
      return
    }
    if (
      getDistanceFromLatLonInKm(
        smoothLocation.lat,
        smoothLocation.lng,
        originalLocation.lat,
        originalLocation.lng
      ) > SHORT_RANGE_DISTANCE_THRESHOLD
    ) {
      setSmoothLocation(originalLocation)
      return
    }

    setIsFinal(false)

    const startTime = Date.now()
    const startLocation = {lat: smoothLocation.lat, lng: smoothLocation.lng}
    const endLocation = {lat: originalLocation.lat, lng: originalLocation.lng}

    const animDuration = 1000

    const animate = () => {
      const now = Date.now()
      const elapsed = now - startTime
      const progress = elapsed / animDuration
      const easedProgress = easeInOut(progress)

      const newLocation = {
        lat: startLocation.lat + (endLocation.lat - startLocation.lat) * easedProgress,
        lng: startLocation.lng + (endLocation.lng - startLocation.lng) * easedProgress
      }
      setSmoothLocation(newLocation)
      if (progress < 1) {
        setTimeout(animate, 1000 / ANIM_FPS)
      } else {
        setIsFinal(true)
      }
    }
    animate()
  }, [originalLocation.lat, originalLocation.lng])

  return {
    smoothLocation,
    isFinal
  }
}
